module.exports = __webpack_public_path__ + "static/media/customize-icon.cb76fb14.svg";